module.exports = __webpack_public_path__ + "55e45681781dab481a6e83c3f24784f1.pdf";